
























































































































































































































































import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig } from "@/components/root/modal";
import { computed, onMounted, ref, Ref } from "@vue/composition-api";
import { FileSummary } from "@/common/models/entity-summary.model";
import { objectsSummary } from "@/common/api/summary.api";
import { InfoTypeHelper, POPULATION_TYPE } from "@/common/models";
import LevelLabel from "@/components/LevelLabel.vue";
import { SharedState } from "@/common/state";
import SensitivityLabel from "../SensitivityLabel.vue";
import { getEntityById } from "@/common/api/entities.api";
import Processing from "../table/Processing.vue";
import { AppAnalytics } from "@/analytics";
import EmptyCell from "../EmptyCell.vue";
import { getInfoType } from "@/common/state/infotypes";
import SpiMarker from "../SpiMarker.vue";
export default Vue.extend({
  components: {
    Modal,
    LevelLabel,
    SensitivityLabel,
    Processing,
    EmptyCell,
    SpiMarker,
  },
  props: ["modalData"],
  setup(props, { emit, root: { $router } }) {
    const feature_pii = SharedState.FeatureHelper.is_enabled("pii_labeler");
    const config: ModalConfig = {
      title: "",
      desc: "",
      blank: true,
      width: "55rem",
      height: feature_pii ? "60rem" : "50rem",
      withTopRightCloseBtn: true,
    };

    const summary: Ref<FileSummary | null> = ref(null);

    onMounted(async () => {
      AppAnalytics.report({
        component: "General",
        eventName: `user opened FileDetailsModal in page :${$router.currentRoute.name}`,
      });
      // @ts-ignore
      const fileId: string = props.modalData.id;
      const res = await objectsSummary({
        ids: [fileId],
        type: POPULATION_TYPE.FILE,
      });

      if (res.success) {
        summary.value = res.value[0] as FileSummary;
      }
    });

    const invEntity = async (entity: { id: string }) => {
      AppAnalytics.report({
        component: "General",
        eventName: `user presed to investigate an employee from FileDetailsModal in page :${$router.currentRoute.name}`,
      });
      emit("cancel");
      if (entity && entity.id) {
        const res = await getEntityById(entity.id);
        if (res.success) {
          // @ts-ignore
          SharedState.investigation.investigate({
            ...res.value,
            type: POPULATION_TYPE.EMPLOYEE,
          });
        }
      }
    };

    const goToCluster = async () => {
      AppAnalytics.report({
        component: "General",
        eventName: `user presed to investigate a file from FileDetailsModal in page :${$router.currentRoute.name}`,
      });
      const file: any = props.modalData;
      emit("cancel");
      // @ts-ignore
      SharedState.investigation.investigate({
        // @ts-ignore
        ...file,
        cluster_id: file.clusterUID,
        type: POPULATION_TYPE.FILE,
      });
    };

    const ctx_label = computed(() => {
      // @ts-ignore
      const { ctxLabels, has_context_labels } = props.modalData;
      if (has_context_labels) {
        return ctxLabels[0].name;
      } else {
        return "";
      }
    });

    const ctx_post_fix = computed(() => {
      // @ts-ignore
      const { ctxLabels, has_context_labels } = props.modalData;
      if (has_context_labels) {
        const { is_folder, category } = ctxLabels[0];
        if (is_folder) return "Folder's info";
        if (category === "Department") return "Department info";
      } else {
        return "";
      }
    });

    const information_tree = computed(() => {
      // @ts-ignore
      if (props.modalData.information) {
        // @ts-ignore
        const info_id = props.modalData.information.id;
        const parents = SharedState.get_label_parents(info_id);
        return parents.map((d: any) => d.labelName).join(" > ");
      } else {
        return "";
      }
    });

    return {
      feature_pii,
      information_tree,
      config,
      summary,
      invEntity,
      goToCluster,
      ctx_label,
      ctx_post_fix,
    };
  },
});
